import {
  Button,
  Col,
  Input,
  InputRef,
  Modal,
  Row,
  Select,
  Tooltip,
} from "antd";
import { Dispatch, SetStateAction, useEffect, useRef } from "react";
import Title from "../../../UI/Title/Title";
import { useTranslation } from "react-i18next";
import ResetButton from "../../../UI/ResetButton/resetbutton";
import HistoryList from "./HistoryList";
import image from "../../../../images/FilterOutlined gray.png";
import { useMutation } from "react-query";
import { Sale, getSale, getSaleById } from "../../../../api/sales";
import { useState } from "react";
import { useReactToPrint } from "react-to-print";
import HistoryPrinter from "../../HistoryPrinter";
import { PrinterOutlined } from "@ant-design/icons";
import SearchIcon from "@mui/icons-material/Search";

type PropsType = {
  isOpenHistory: boolean;
  setisOpenHistory: Dispatch<SetStateAction<boolean>>;
};
interface SessionData {
  total: string;
  receiptsTotalMainAmountText: string;
  receiptsTotalSecondaryAmountText: string;
  salesTotalMainAmountText: string;
  salesTotalSecondaryAmountText: string;
}
const HistoryModal = ({ isOpenHistory, setisOpenHistory }: PropsType) => {
  const [t] = useTranslation("common");
  const [page, setPage] = useState<number>(1);
  const [sales, setSales] = useState<Sale[]>();
  const [selectedInvoice, setSelectedInvoice] = useState<any>();
  const [itemsToPrint, setItemsToPrint] = useState<any>();
  const [tableKey, setTableKey] = useState("");
  const [search, setSearch] = useState<string>("");
  const [filter, setFilter] = useState<boolean | undefined>(undefined);
  const sessionId = localStorage.getItem("sessionId") || "";
  const [sessionData, setSessionData] = useState<SessionData>();
  const [visible, setVisible] = useState(false);

  const resetFilters = () => {
    getSales({
      limit: page * 10 + 10,
      session: sessionId,
      q: "",
    }).then((res) => {
      setSales(res.data?.data);
      setSearch("");
      setTableKey((tableKey) => tableKey + 1);
      setFilter(undefined);
    });
  };

  const handleSearch = () => {
    getSales({
      limit: page * 10 + 10,
      session: sessionId,
      isPaid: filter,
      q: search,
    }).then((res: any) => {
      setSales(res.data?.data);
    });
  };

  const handleFilter = (value: boolean | undefined) => {
    setFilter(value);
    const isPaid = value === undefined ? undefined : value;
    getSales({
      limit: page * 10 + 10,
      session: sessionId,
      isPaid: isPaid,
      q: "",
    }).then((res: any) => {
      setSales(res.data?.data);
    });
  };

  const getSales = async (params: {
    session: number | string | undefined;
    limit: number;
    isPaid?: boolean;
    q: string;
  }) => {
    // Make your API request here using the updated parameters
    return await SaleMutation(params);
  };
  const { mutateAsync: SaleMutation, isLoading: SaleLoading } = useMutation(
    "getsale",
    getSale,
    {
      onSuccess: (res: any) => {
        setSessionData(res.data);
      },
    }
  );

  useEffect(() => {
    isOpenHistory &&
      SaleMutation({
        limit: page * 10 + 10,
        session: sessionId,
        q: "",
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpenHistory]);

  const { mutateAsync: getSaleByIdMutation } = useMutation(
    "getSaleById",
    () => getSaleById(selectedInvoice),
    {
      onSuccess: (result) => {
        setItemsToPrint(result.data);
      },
    }
  );

  useEffect(() => {
    itemsToPrint && handlePrint();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [itemsToPrint]);

  const componentRef = useRef<any>();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    onAfterPrint: () => {
      setSelectedInvoice(null);
    },
  });
  const searchRef = useRef<InputRef>(null);
  useEffect(() => {
    if (isOpenHistory) {
      setTimeout(() => {
        searchRef.current?.focus();
      }, 0);
    }
  }, [isOpenHistory]);

  useEffect(() => {
    if (visible) {
      getSales({
        limit: page * 10 + 10,
        session: sessionId,
        q: "",
      }).then((res) => {
        setSales(res.data?.data);
      });
    }
  }, [visible, page, sessionId]);

  useEffect(() => {
    setVisible(isOpenHistory);
  }, [isOpenHistory]);
  return (
    <>
      <Modal
        // visible={visible}
        maskClosable={false}
        closable={false}
        centered
        open={isOpenHistory}
        okButtonProps={{ style: { display: "none" } }}
        onCancel={() => {
          setItemsToPrint(null);
          setisOpenHistory(false);
          document.body.classList.remove("body-scroll-lock");
        }}
        cancelText={t('cancel')}
        width={1200}
        cancelButtonProps={{
          style: {
            color: "#1677FF",
            border: "1px solid #1677FF",
            height: "40px",
            width: "100px",
          },
        }}
      >
        <Row gutter={[10, 10]}>
          <Col span={23}>
            <Title title={`${t("history")}`} />
          </Col>
          <Col
            span={23}
            className="modaltitleEdit"
            style={{ marginBottom: "20px" }}
          >
            {t("list-of-all-invoices")}
          </Col>
          <Col span={24}>
            <span className="colcolor"> {t("total-invoices")}&nbsp; </span>
            <span className="spancolor"> {sessionData?.total}&nbsp; </span>
            <span className="colcolor"> {t("Total-sales")} </span> &nbsp;
            <span className="spancolor">
              {sessionData?.salesTotalMainAmountText}
            </span>
            &nbsp; / &nbsp;
            <span className="spancolor">
              {sessionData?.salesTotalSecondaryAmountText}
            </span>
            &nbsp;
            <span className="colcolor"> {t("Total-receipts")} </span>&nbsp;
            <span className="spancolor">
              {sessionData?.receiptsTotalMainAmountText}
            </span>
            &nbsp; / &nbsp;
            <span className="spancolor">
              {sessionData?.receiptsTotalSecondaryAmountText}
            </span>
            &nbsp;
          </Col>
          <Col span={6}>
            <Input
              ref={searchRef}
              className="search"
              placeholder={`${t("search")}`}
              value={search}
              onPressEnter={(e: any) => e.code === "Enter" && handleSearch()}
              onChange={(e: any) => setSearch(e.target.value)}
              suffix={
                <Tooltip>
                  <SearchIcon
                    onClick={() => handleSearch()}
                    style={{
                      fontSize: "20px",
                      color: "#BDBDBD",
                      cursor: "pointer",
                    }}
                  />
                </Tooltip>
              }
            />
          </Col>
          <Col span={3}>
            <Select
              key={tableKey}
              onChange={(value: boolean | undefined) => handleFilter(value)}
              value={filter}
              placeholder={`${t("filter")}`}
              style={{ width: "110%" }}
              size="large"
              suffixIcon={<img src={image} alt="" />}
              options={[
                {
                  value: true,
                  label: t("paid"),
                },
                {
                  value: false,
                  label: t("unpaid"),
                },
              ]}
            />
          </Col>
          <Col
            offset={12}
            span={1}
            style={{ display: "flex", alignItems: "center" }}
          >
            <Button
              className="Button"
              type="text"
              icon={
                <PrinterOutlined
                  style={{ color: "#212121", fontSize: "25px" }}
                />
              }
              onClick={() => {
                getSaleByIdMutation();
              }}
              size={"small"}
            />
          </Col>
          <Col span={2}>
            <ResetButton
              onClick={() => {
                resetFilters();
              }}
            />
          </Col>
          <Col span={24}>
            <HistoryList
              tableKey={tableKey}
              sales={sales}
              page={page}
              setPage={setPage}
              setSales={setSales}
              selectedInvoice={selectedInvoice}
              setSelectedInvoice={setSelectedInvoice}
              search={search}
              sessionId={sessionId}
              SaleLoading={SaleLoading}
              SaleMutation={SaleMutation}
            />
          </Col>
        </Row>
        <div style={{ display: "none" }}>
          {itemsToPrint && (
            <HistoryPrinter data={itemsToPrint} componentRef={componentRef} />
          )}
        </div>
      </Modal>
    </>
  );
};

export default HistoryModal;
